angular.module('elogbooksDirectives').directive('elogbooksLocation', ['lodash', '$uibModal', function (lodash, $uibModal) {
    return {
        restrict: 'AE',
        require: ['ngModel'],
        scope: {
            model: '=ngModel',
            location: '=',
            locations: '=',
            returnObject: '@',
            isRequired: '=',
            readonly: '=?',
            parentAdd: '=?',
            key: '='
        },
        templateUrl: '/modules/directives/form-elements/location/location.html',
        link: function(scope, element, attrs) {
            scope.readonly = scope.readonly || false;
            // Events required
            scope.raiseEvents = lodash.has(attrs, 'raiseEvents');
        },
        controller: function ($scope, $sce, apiClient, $uibModal) {
            $scope.loading = false;
            $scope.onSelect = onSelect;
            $scope.onSearch = onSearch;
            $scope.onLoadMore = onLoadMore;
            $scope.onClear = onClear;
            $scope.createNewLocationModal = createNewLocationModal;
            $scope.parentAdd = $scope.parentAdd === false ? false : true;

            if ($scope.location && $scope.location.href && typeof $scope.location.path === 'undefined') {
                apiClient.get($scope.location.href).then(function (response) {
                    $scope.location = response;
                    generateSelectedLocationFormFields(response);
                });
            }

            $scope.$watch('locations', function($newVal) {
                if ($scope.locationFormFields && $scope.location) {
                    // Input used in edit mode
                    generateSelectedLocationFormFields($scope.location);
                } else {
                    // Input used in add mode
                    $scope.locationFormFields = [];
                    $scope.locationFormFields.push(createFormField($newVal, null));
                }
            }, true);

            function onLoadMore($event, index) {
                if ($scope.loading || !$scope.locationFormFields[index]) {
                    return;
                }

                $scope.locationFormFields[index].noMore = false;

                if ($scope.locationFormFields[index].page < $scope.locationFormFields[index].pages) {
                    $event.stopPropagation();
                    $event.preventDefault();

                    $scope.loading = true;

                    apiClient.get($scope.locationFormFields[index]._links.next.href, this.linkParameters).then(function (response) {
                        $scope.locationFormFields[index].locations = $scope.locationFormFields[index].locations.concat(response.locations);
                        $scope.locationFormFields[index].response = response;
                        $scope.locationFormFields[index].page = response.page;
                        $scope.locationFormFields[index].pages = response.pages;
                        $scope.locationFormFields[index]._links = response._links;
                        $scope.locationFormFields[index].noMore = $scope.locationFormFields[index].page === $scope.locationFormFields[index].pages;
                        $scope.loading = false;
                    });
                }
            }

            function onSelect($item, $index, $child) {
                $scope.locationFormFields.splice($index + 1, $scope.locationFormFields.length);

                if ($scope.returnObject) {
                    $scope.model = { href: $item };
                } else {
                    $scope.model = { href: $item._links.self.href };
                    $scope.locationFormField = {
                        selected: $item._links.self.href
                    };
                }

                if ($scope.key >= 0) {
                    $scope.model.key = $scope.key;
                }

                if ($item._links.children !== undefined) {
                    apiClient.get($item._links.children.href).then(function (response) {
                        if (response.count > 0) {
                            $scope.locationFormFields.push(createFormField(response, $child));
                        }
                    });
                }
                if ($scope.raiseEvents) {
                    $scope.$emit('location:select:click', $scope.model);
                }
            }

            function onSearch(keyword, index) {
                // hide the load-more button whilst searching
                if (!$scope.locationFormFields[index]) {
                    return;
                }
                $scope.locationFormFields[index].noMore = true;

                if ($scope.locationFormFields[index].response
                    && $scope.locationFormFields[index].response.getLink('self')
                    && !$scope.loading
                ) {
                    $scope.loading = true;

                    // Async function needs to access object properties from global scope
                    apiClient.get($scope.locationFormFields[index].response.getLink('self'), {name: keyword, page:1}).then(function (response) {
                        $scope.loading = false;
                        $scope.keyword = keyword;
                        $scope.locationFormFields[index].locations = response.locations;
                        $scope.locationFormFields[index].response = response;
                        $scope.locationFormFields[index].page = response.page;
                        $scope.locationFormFields[index].pages = response.pages;
                        $scope.locationFormFields[index].response = response;
                        $scope.locationFormFields[index].noMore = $scope.locationFormFields[index].page === $scope.locationFormFields[index].pages;
                    });
                } else {
                    $scope.loading = false;
                }
            }

            function onClear($index) {
                $scope.locationFormFields.splice($index + 1, $scope.locationFormFields.length);
                $scope.locationFormFields[$index].selected = null;
                if ($scope.locationFormFields[$index - 1]) {
                    const item = $scope.locationFormFields[$index - 1];

                    if ($scope.returnObject) {
                        $scope.model = item.selected;
                    } else {
                        $scope.model = item.selected._links.self;
                    }
                } else {
                    delete $scope.model;
                }

                if ($scope.raiseEvents) {
                    $scope.$emit('location:select:clear', $index);
                }
            }

            function createFormField($locations, $location) {

                if ($location && typeof $location.title !== 'undefined') {
                    $location.name = $location.title;
                }

                var noMore = true;

                if ($locations?.hasOwnProperty('locations')) {

                    if ($locations.page !== $locations.pages) {
                        noMore = false;
                    }

                    return {
                        selected: $location,
                        locations: $locations.locations,
                        limit: 30,
                        page: $locations.page,
                        pages: $locations.pages,
                        _links: $locations._links,
                        response: $locations,
                        noMore: noMore
                    };
                }

                return {
                    selected: $location,
                    locations: $locations,
                    noMore: noMore
                };

            }

            function createNewLocationModal() {
                // Determine youngest child that has an option selected
                var youngestChildIndex = null;
                youngestChildIndex = lodash.findLastIndex($scope.locationFormFields, function(n) {
                    return n.selected !== undefined && n.selected !== null;
                });

                var parentLocation = null;
                if (youngestChildIndex >= 0 && $scope.locationFormFields[youngestChildIndex].selected) {
                    parentLocation = $scope.locationFormFields[youngestChildIndex].selected;
                }

                var modalInstance = $uibModal.open({
                                    templateUrl: '/modules/common/modals/create-location/create-location-modal.html',
                                    controller: 'CreateLocationModalController',
                                    controllerAs: 'vm',
                                    resolve: {
                                        parentLocation: function() {
                                            return parentLocation;
                                        },
                                        createLink: function() {
                                            return $scope.locationFormFields[0]._links.create.href;
                                        }
                                    }
                });

                modalInstance.result.then(function (item) {
                    if (parentLocation === null) {
                        $scope.locationFormFields = [];
                        $scope.locationFormFields.push(createFormField($scope.locations, item));
                        $scope.model = { href: item.getLink('self') };
                        onSelect($scope.model, 0);
                    } else {
                        $scope.locationFormFields.push(createFormField([item], item));
                        onSelect(parentLocation, youngestChildIndex, item);
                        $scope.model = { href: item.getLink('self') };
                    }

                });
            }

            function generateSelectedLocationFormFields(response) {
                const locationPaths = response.path
                if ($scope.locations && locationPaths && locationPaths.length > 0) {
                    $scope.locationFormFields = [];
                    angular.forEach(locationPaths, function (locationPath, index) {
                        if (index === 0) {
                            // Set the first form field with existing locations data
                            $scope.locationFormFields.push(createFormField($scope.locations, locationPath));
                            if (
                                locationPaths.length === 1 &&
                                !$scope.readonly
                            ) {
                                // in edit mode load last dropdown with none selected
                                generateLastLocationFormField(locationPath.id);
                            }
                        } else {
                            // Temporary field with selected item until the api response
                            $scope.locationFormFields[index] = createFormField([locationPath], locationPath);
                            // call the api with parent filter to get the next level
                            if(!$scope.readonly) {
                                apiClient.get($scope.locations.getLink('first'), { parent: locationPath.parentId }).then(function (response) {
                                    $scope.locationFormFields[index] = createFormField(response, locationPath);
                                    if(index === locationPaths.length - 1) {
                                        // in edit mode load last dropdown with none selected
                                        generateLastLocationFormField(locationPath.id)
                                    }
                                });
                            }
                        }
                    })
                }
            }

            function generateLastLocationFormField(parent) {
                apiClient.get($scope.locations.getLink('first'), { parent }).then(function (response) {
                    if(response.count > 0) {
                        $scope.locationFormFields.push(createFormField(response));
                    }
                });
            }
        }
    };
}]);
